import HeaderRoutingLoader from './headerRoutingLoader'

export default HeaderRoutingLoader
